import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';

import configureStore from './store/configure';
import Comps from './comps';

import './styles.scss';
import { defaultLeaseColumns, defaultSaleColumns, initialState } from 'helpers/comps/database_table_constants';

export class CompsIndex extends React.Component {
  static propTypes = {
    assetClasses: PropTypes.array.isRequired,
    availabilities: PropTypes.array.isRequired,
    availableRailProviders: PropTypes.array.isRequired,
    buildingClass: PropTypes.array.isRequired,
    canExport: PropTypes.bool.isRequired,
    canViewUnreleasedFeatures: PropTypes.bool,
    currentUser: PropTypes.object.isRequired,
    customFieldSchemas: PropTypes.array.isRequired,
    databaseId: PropTypes.number.isRequired,
    dromoImporterProps: PropTypes.object,
    features: PropTypes.object.isRequired,
    googleMapsApiKey: PropTypes.string,
    investmentTypes: PropTypes.array.isRequired,
    leaseSpaceType: PropTypes.array.isRequired,
    leaseType: PropTypes.array.isRequired,
    leaseUnits: PropTypes.array.isRequired,
    lotBorderTypes: PropTypes.array.isRequired,
    lotStabilizations: PropTypes.array.isRequired,
    markerAnchor: PropTypes.array.isRequired,
    markerClustererStyles: PropTypes.array.isRequired,
    marketTypeOptions: PropTypes.array.isRequired,
    microMarketTypeOptions: PropTypes.array.isRequired,
    paths: PropTypes.object.isRequired,
    servedRailProviders: PropTypes.array.isRequired,
    subMarketTypeOptions: PropTypes.array.isRequired
  };

  store = configureStore({
    customFieldSchemas: this.props.customFieldSchemas,
    dromoImporterProps: this.props.dromoImporterProps,
    features: this.props.features,
    paths: this.props.paths,
    query: {
      leasePage: 1,
      leaseSort: 'name asc',
      salePage: 1,
      saleSort: 'name asc',
      searchText: '',
      availabilities: [],
      assetClasses: [],
      buildingClasses: [],
      investmentTypes: [],
      addressFilter: { ...initialState.addressFilter },
      leaseFilter: { ...initialState.leaseFilter },
      saleFilter: { ...initialState.saleFilter },
      industrialFilter: { ...initialState.industrialFilter },
      multifamilyFilter: { ...initialState.multifamilyFilter },
      propertyFilter: { ...initialState.propertyFilter },
    },
    savedSearches: {
      loading: true,
      deleteSavedSearch: null
    },
    scope: {
      canViewUnreleasedFeatures: this.props.canViewUnreleasedFeatures,
      currentUser: this.props.currentUser,
      databaseId: this.props.databaseId
    },
    static: {
      assetClasses: this.props.assetClasses,
      availabilities: this.props.availabilities,
      availableRailProviders: this.props.availableRailProviders,
      buildingClasses: this.props.buildingClass,
      investmentTypes: this.props.investmentTypes,
      leaseSpaceTypeMappings: this.props.leaseSpaceType,
      leaseTypeMappings: this.props.leaseType,
      leaseUnits: this.props.leaseUnits,
      lotBorderTypes: this.props.lotBorderTypes,
      lotStabilizations: this.props.lotStabilizations,
      marketTypeOptions: this.props.marketTypeOptions,
      microMarketTypeOptions: this.props.microMarketTypeOptions,
      servedRailProviders: this.props.servedRailProviders,
      subMarketTypeOptions: this.props.subMarketTypeOptions,
    },
    search: {
      initialFetchComplete: false,
      isFetching: true,
      leases: [],
      meta: {
        currentPage: 0,
        pageSize: 25,
        compIds: [],
        mapLocations: [],
        totalCount: 0,
        totalPages: 0,
      },
      sales: []
    },
    selectList: {
      selectedLeaseIds: [],
      selectedSaleIds: []
    },
    session: {
      currentSaleColumns: [...defaultSaleColumns],
      currentLeaseColumns: [...defaultLeaseColumns]
    },
    ui: {
      activeMapComp: null,
      currentTab: 'lease',
      currentView: 'list',
      canExport: this.props.canExport,
      defaultSaleColumns: [...defaultSaleColumns],
      defaultLeaseColumns: [...defaultLeaseColumns],
      googleMapsApiKey: this.props.googleMapsApiKey || '',
      markerAnchor: this.props.markerAnchor,
      markerClustererStyles: this.props.markerClustererStyles,
      showMapInfoWindow: false,
      showMapList: true,
      showColumnFilters: false
    }

  })

  render() {
    return (
      <Provider store={this.store}>
        <Comps />
      </Provider>
    );
  }
}

export default CompsIndex;
